<div class="search-bar">
  <img src="./assets/images/gray-search.svg" alt="Search Icon" />
  <input
    type="text"
    [placeholder]="placeholder | allLettersCapital"
    autocomplete="off"
    [(ngModel)]="searchKeyword"
    (input)="onSearchInput()"
    class="search"
  />
</div>
